import {
  GET_SETTING,
  GET_SETTING_SUCCESS,
  GET_SETTING_FAILED,
} from "./actionTypes";

export const getSetting = (params) => {
  return {
    type: GET_SETTING,
    payload: params
  };
};

export const getSettingSuccess = (settings) => {
  return {
    type: GET_SETTING_SUCCESS,
    payload: settings,
  };
};

export const getSettingFailed = (error) => {
  return {
    type: GET_SETTING_FAILED,
    payload: error,
  };
};
